import React from 'react';
import styled from 'styled-components';

// Theme
import { colors } from '../../theme/theme';

const CustomButton = styled.button`
    outline: none;
    background-color: transparent;
    border: none;
    &:focus {
      boxShadow: none;
    };
    &:hover {
      backgroundColor: transparent;
      border: none;
      cursor: pointer;
    };
    &:disabled {
      backgroundColor: transparent;
      border: none;
      color: ${colors.lightGrey};
    };
    &:active {
      backgroundColor: transparent;
      border: none;
    };
`;

const Text = styled.span`
  font-family: Roboto-Regular;
  font-size: 14px;
  color: ${colors.lightBlue};
`;

interface ButtonLinkProps {
  onClick: () => void,
  text?: string,
  children?: any,
  className?: string,
}

const ButtonLink = React.memo(({
  onClick,
  text,
  children,
  className = '',
}: ButtonLinkProps) => (
  <CustomButton
    onClick={onClick}
    className={className}
  >
    <Text>{text}</Text>
    {children && children}
  </CustomButton>
));

export default ButtonLink;
